import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
import TableList from '../../components/TableList';
import { ContextMenu } from '../../components/context-menu/context-menu';
import { MessengerBox } from '../../components/messenger-box/messenger-box';
import { Popup } from '../../components/Popup/popup';
import { CheckBox } from '../../components/checkboxes/check-box';
import * as UnitHelper from '../../helper/unit-helper';
import { AppSettings } from '../../constants';
import * as WorkOrderTypeActionType from '../constants';
import { AddEditWorkOrderType } from './add-edit-work-order-type';
import '../work-order-type.css';

const defaultParams = {
  defaultSortName: 'name',
  defaultSortOrder: 'ascending',
  sizePerPage: 10
};

let interval = null;

const TABLE_NAME = 'WORK_ORDER_TYPE_LIST';

class WorkOrderType extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    WorkOrderTypesStore: PropTypes.object,
    PageSizeReference: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.sizePerPage = UnitHelper.initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.WorkOrderTypesStore.ManageWorkOrderTypes.params.take
    );

    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      currentPage: 1,
      sizePerPage: this.sizePerPage,
      totalRecord:
        props.WorkOrderTypesStore.ManageWorkOrderTypes.params.totalRecord,
      data: props.WorkOrderTypesStore.ManageWorkOrderTypes.items,
      status: props.WorkOrderTypesStore.ManageWorkOrderTypes.params.status,

      columns: [
        {
          title: 'Type',
          name: 'name',
          sort: true,
          defaultSortOrder: 'ascending',
          customRender: this.customRenderName.bind(this)
        },
        {
          title: '',
          name: '',
          className: 'cls-colm-action',
          customRender: this.customRenderBtnAction.bind(this)
        }
      ],
      isShowPopup: false,
      checkedValues: ['active', 'inActive']
    };
  }

  componentDidMount() {
    this.binding(
      this.objToParams({
        ...this.props.WorkOrderTypesStore.ManageWorkOrderTypes.params,
        take: this.state.sizePerPage
      })
    );
    setInterval(() => {
      if (this.state.detectInputSearchInterVal === 2) {
        this.setState({ detectInputSearchInterVal: 0 }, () => {
          clearInterval(interval);
          const params = this.objToParams(
            this.props.WorkOrderTypesStore.ManageWorkOrderTypes.params
          );
          params.name = '';
          this.binding({
            ...params,
            status: 'all',
            skip: 0
          });
        });
      }
    }, 500);

    const self = this;
    window.addEventListener('click', e => {
      if (
        document.getElementById('s1-popup') &&
        document.getElementById('s1-popup').contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById('popup-button') &&
          document.getElementById('popup-button').contains(e.target)
        ) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({ isShowPopup: false });
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const {
      WorkOrderTypesStore: { ManageWorkOrderTypes }
    } = nextProps;
    if (ManageWorkOrderTypes) {
      this.setState({
        totalRecord: ManageWorkOrderTypes.params.totalRecord,
        data: ManageWorkOrderTypes.items,
        status: ManageWorkOrderTypes.params.status
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      UnitHelper.dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage
      );
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: WorkOrderTypeActionType.RESET_REQUEST_WORK_TYPE,
      params: null
    });
  }

  customRenderName(item) {
    var style = {};

    if (!item.isActive) {
      style = { opacity: 0.5 };
    }

    return <span style={style}>{item.name}</span>;
  }

  customRenderBtnAction(item) {
    return (
      <a
        className='glyphicon glyphicon-option-vertical cls-table-black-icon'
        onClick={e => {
          this.onContextMenu(e, item);
        }}
      />
    );
  }

  binding(params) {
    this.props.dispatch({
      type: WorkOrderTypeActionType.SEARCH_REQUEST_WORK_TYPE_ASYNC,
      params: params
    });
  }

  onTableBinding(configTable) {
    var params = this.objToParams(
      this.props.WorkOrderTypesStore.ManageWorkOrderTypes.params
    );

    this.binding({
      ...params,
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take
    });
  }

  objToParams(obj) {
    return {
      searchKey: this.search.value.trim(),
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      status: obj.status,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  onOpenAddEditPopup(e, item) {
    if (typeof item === 'undefined') {
      this.props.dispatch({
        type: WorkOrderTypeActionType.OPEN_FORM_CREATE_REQUEST_WORK_TYPE,
        params: null
      });
    } else {
      this.props.dispatch({
        type: WorkOrderTypeActionType.GET_REQUEST_WORK_TYPE_BY_ID_ASYNC,
        params: item.id
      });
    }
  }

  handleChange = (e, value) => {
    if (this.state.checkedValues.includes(value)) {
      this.setState(
        {
          checkedValues: [
            ...this.state.checkedValues.filter(item => item !== value).sort()
          ]
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    } else {
      this.setState(
        {
          checkedValues: [...this.state.checkedValues, value].sort()
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    }
  };

  onTogglePopupFilter = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup
    });
  };

  onContextMenu(e, item) {
    var contextItem = [];

    if (item.status === 1) {
      contextItem = [
        {
          title: 'Edit',
          icon: 'glyphicon glyphicon-pencil',
          event: this.onOpenAddEditPopup.bind(this)
        }
        // {
        //   title: 'Make inactive',
        //   icon: 'glyphicon glyphicon-minus-sign',
        //   event: this.onMakeInActive.bind(this)
        // }
      ];
    } else {
      contextItem = [
        {
          title: 'Edit',
          icon: 'glyphicon glyphicon-pencil',
          event: this.onOpenAddEditPopup.bind(this)
        }
        // {
        //   title: 'Make active',
        //   icon: 'glyphicon glyphicon-ok-sign',
        //   event: this.onMakeActive.bind(this)
        // }
      ];
    }

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onMakeInActive = (e, item) => {
    this.msgBox.confirm(
      null,
      'All of item name\'s associated problems are going to be also deactivated. Continue ?',
      () => {
        this.onSave(
          e,
          item.id,
          WorkOrderTypeActionType.MAKE_INACTIVE_WORK_TYPE_ASYNC
        );
      }
    );
  };

  onMakeActive = (e, item) => {
    this.onSave(
      e,
      item.id,
      WorkOrderTypeActionType.MAKE_ACTIVE_WORK_TYPE_ASYNC
    );
  };

  onSave(e, data, actionType) {
    var params = {
      ...this.objToParams(
        this.props.WorkOrderTypesStore.ManageWorkOrderTypes.params
      ),
      searchKey: this.search.value.trim()
    };

    this.props.dispatch({
      type: actionType,
      params: {
        data: data,
        search: params
      }
    });
  }

  onSearch() {
    var params = this.objToParams(
      this.props.WorkOrderTypesStore.ManageWorkOrderTypes.params
    );

    this.setState({
      checkedValues: ['active', 'inActive']
    });

    this.binding({
      ...params,
      status: 'all',
      skip: 0
    });
  }

  onEnter(e) {
    if (e.key === 'Enter') {
      this.onSearch(e);
    }
  }

  onChangeInputSearch = e => {
    if (isEmpty(e.target.value)) {
      interval = setInterval(() => {
        this.setState({
          detectInputSearchInterVal: this.state.detectInputSearchInterVal + 1
        });
      }, 1000);
    } else {
      clearInterval(interval);
      this.setState({ detectInputSearchInterVal: 0 });
    }
  };

  onChecked(e, data) {
    var status = UnitHelper.isEmpty(data.toString()) ? '' : data.toString();
    if (status === '') {
      this.setState({ data: null });
    } else {
      var params = this.objToParams(
        this.props.WorkOrderTypesStore.ManageWorkOrderTypes.params
      );
      if (data.length === 2) {
        status = 'all';
      }
      this.binding({
        ...params,
        status: status,
        skip: 0
      });
    }
  }

  onCloseModal = () => {
    this.props.dispatch({
      type: WorkOrderTypeActionType.CLOSE_FORM_CREATE_REQUEST_WORK_TYPE,
      params: null
    });
  };

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.props.dispatch({
          type: WorkOrderTypeActionType.SEARCH_REQUEST_WORK_TYPE_ASYNC,
          params: {
            searchKey: this.search.value.trim(),
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            status: this.state.status,
            skip: params.currentPage - 1,
            take: params.sizePerPage
          }
        });
      }
    );
  }

  refreshPageList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.props.dispatch({
          type: WorkOrderTypeActionType.SEARCH_REQUEST_WORK_TYPE_ASYNC,
          params: {
            searchKey: this.search.value.trim(),
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            status: this.state.status,
            skip: params.currentPage - 1,
            take: params.sizePerPage
          }
        });
      }
    );
  }

  render() {
    const data = this.state.data;

    const column = [
      {
        field: 'id',
        header: 'id',
        hidden: true,
        isKey: true,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left'
      },
      {
        field: 'name',
        header: 'Type',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left'
      },
      {
        field: '',
        header: '',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'right',
        headerAlign: 'right',
        customRender: this.customRenderBtnAction.bind(this),
        className: 'column-action',
        columnClassName: 'column-action'
      }
    ];

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: this.state.totalRecord
    };

    const customHeader = (
      <div className='table-header'>
        <Row>
          <Col sm={12} md={12} className='text-right'>
            <div className='box-search'>
              <div className='input-group'>
                <input
                  type='text'
                  id='txt-search-email'
                  ref={ref => {
                    this.search = ref;
                  }}
                  className='form-control'
                  placeholder='Search'
                  onKeyPress={this.onEnter.bind(this)}
                  onChange={this.onChangeInputSearch}
                />
                <span className='input-group-btn'>
                  <button
                    onClick={this.onSearch.bind(this)}
                    className='btn btn-secondary'
                  >
                    <span className='fa fa-search' aria-hidden='true' />
                  </button>
                </span>
              </div>
            </div>

            <div className='manage-user-filter pull-right'>
              <button
                onClick={this.onTogglePopupFilter}
                className='btn btn-secondary fa fa-filter btn-icon'
                id='popup-button'
              />
              {this.state.isShowPopup && (
                <Popup
                  ref={ref => {
                    this.popup = ref;
                  }}
                >
                  <CheckBox
                    checked={this.state.checkedValues.includes('active')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='active'
                    label='Active'
                    handleChange={this.handleChange}
                  />
                  <CheckBox
                    checked={this.state.checkedValues.includes('inActive')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='inActive'
                    label='InActive'
                    handleChange={this.handleChange}
                  />
                </Popup>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <div id='manage-user'>
        <div className='page-title clearfix'>
          <h2 className='pull-left'>
            Work order types ({this.state.totalRecord})
          </h2>
          <button
            className='btn btn-primary btn-info btn-siteone pull-right btn-icon'
            onClick={ref => {
              this.onOpenAddEditPopup(ref);
            }}
          >
            <span className='fa fa-plus icon' />
            NEW
          </button>
        </div>
        <AddEditWorkOrderType
          item={this.props.WorkOrderTypesStore.WorkOrderTypeProfile}
          errorMsg={this.props.WorkOrderTypesStore.ErrorMsg}
          show={this.props.WorkOrderTypesStore.IsOpenFormAddEdit}
          isCreate={this.props.WorkOrderTypesStore.IsCreate}
          title={this.props.WorkOrderTypesStore.Title}
          onSubmit={this.onSave.bind(this)}
          onCloseModal={this.onCloseModal}
        />
        <ContextMenu
          ref={ref => {
            this.cxtMenu = ref;
          }}
        />
        <MessengerBox
          ref={ref => {
            this.msgBox = ref;
          }}
          title={AppSettings.COMPANY_NAME}
        />

        <TableList
          ref={ref => {
            this.tableList = ref;
          }}
          column={column}
          defaultParams={defaultParams}
          data={data}
          options={options}
          refreshPageList={this.refreshPageList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          showButtonMenu={true}
          onContextMenu={this.onContextMenu.bind(this)}
          customTableHeader={customHeader}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    WorkOrderTypesStore: state.WorkOrderTypesStore,
    PageSizeReference: state.BuilderStore.PageSizeReference
  };
};

export default connect(mapStateToProps)(WorkOrderType);



// WEBPACK FOOTER //
// ./src/Work-Order-Type/Containers/manage-work-order-type.js